import {
	type FileConfigDTO,
	type FileConfigListDTO,
	type FileConfigWriteRequest,
	type LogicalFileType,
	TenantConfigPlane,
} from '@today/types'
import { apiClient } from './api.client'

/**
 * The route tree a console plane addresses (TO-391 design D4): a Tenant Admin
 * acts on their own tenant, a Super-Admin on the tenant the console was opened for.
 */
const filesOf = (tenantId: string, plane: TenantConfigPlane) =>
	plane === TenantConfigPlane.PLATFORM
		? `/admin/tenants/${encodeURIComponent(tenantId)}/logical-files`
		: '/logical-files'

/** A tenant's logical file configuration (TO-391; TO-632 de-prefixed to /logical-files). */
export const fileExchangeService = {
	/** `GET …/logical-files` — the five files, in their fixed order. */
	async list(tenantId: string, plane: TenantConfigPlane): Promise<FileConfigListDTO> {
		const { data } = await apiClient.get<FileConfigListDTO>(filesOf(tenantId, plane))
		return data
	},

	/** `PUT …/logical-files/{fileType}` — a full replacement guarded by `expectedVersion`. */
	async save(
		tenantId: string,
		plane: TenantConfigPlane,
		fileType: LogicalFileType,
		body: FileConfigWriteRequest,
	): Promise<FileConfigDTO> {
		const { data } = await apiClient.put<FileConfigDTO>(`${filesOf(tenantId, plane)}/${fileType}`, body)
		return data
	},
}
